// * Bootstrap libraries
import "./_bootstrap";

// * Any other global site-wide JavaScript should be placed below.

(function($) {
    $(document).ready(function() {

        // всплывашки с формами
        $('.fancy-form').fancybox({
            touch: false
        });

        // popup
        $('.commerce-order-item-add-to-cart-form button').click(function() {
            var popupTimeout = setTimeout(() => {
                $.fancybox.open($("#block-cart-message"), {touch: false}, {padding: 0});
                }, 300);
        });
        // popup
        $('.close_popup').click(function() {
            $.fancybox.close();
        });

        // галерея выполненных работ
        $('.field--name-field-gallery-block').photobox('a',{ time:0 });
        $('.field--name-field-license-image').photobox('a',{ time:0 });
        $('.field--name-field-article-image').photobox('a',{ time:0 });
        $('.view-taxonomy-desc .views-row').photobox('a',{ time:0 });

        // слайдер на главной
        $('.slider_block .field--name-field-paragraph-block').slick({
            dots: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            speed: 1000,
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
        });

        // карусель лицензий
        $('.license_block .field--name-field-license-image').slick({
            dots: true,
            infinite: true,
            autoplay: true,
            adaptiveHeight: true,
            autoplaySpeed: 2000,
            speed: 1000,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: '.next_arrow',
            prevArrow: '.prev_arrow'
        });

        // карусель новостей
        $('.blog_block .view-content').slick({
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 1000,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: '.next_blog',
            prevArrow: '.prev_blog',
            responsive: [
                { breakpoint: 992,
                    settings: { slidesToShow: 2 } },
                { breakpoint: 565,
                    settings: { slidesToShow: 1 } },
            ]
        });

        // карусель товаров на главной
/*        $('#quicktabs-container-front-products .quicktabs-tabpage').slick({
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 1000,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: '.next_prod',
            prevArrow: '.prev_prod',
            responsive: [
                { breakpoint: 992,
                    settings: { slidesToShow: 2 } },
                { breakpoint: 565,
                    settings: { slidesToShow: 1 } },
            ]
        });*/

        var current_url = window.location.pathname;
        $('.c-menu-subcategory li a').each(function() { // для каждой ссылки
            var linkHref = $(this).attr('href'); //получаем href
            if (current_url == linkHref){ //сравниваем полученное из адресной строки с href ссылки
                // при совпадении присваиваем класс
                $(this).closest('.c-menu-subcategory li').addClass('active');
                $(this).parents('.c-menu-subcategory>ul>li').addClass('active');
            }
        });

        $('.btn_close').click(function(){
            $('#nav_mobile').removeClass('show');
        });
        $('.fancy_bg_close').click(function(){
            $('#nav_mobile').removeClass('show');
        });

        // del titles brands
        $(".path-katalog-kondicionery .facet_product_brand .facet-item a span").text(function() {
            return $(this).text().replace(/(on|Кондиционеры )/g, '');
        });
        $(".path-katalog-ventilyaciya .facet_product_brand .facet-item a span").text(function() {
            return $(this).text().replace(/(on|Вентиляция )/g, '');
        });
        $(".path-katalog-otoplenie .facet_product_brand .facet-item a span").text(function() {
            return $(this).text().replace(/(on|Отопление )/g, '');
        });

        $(".filters_block .facet-active .block__title").append('<span class="facet-link"><a href=' + current_url + '>Сброс</a></span>');

        // add now year
        var currentYear = new Date().getFullYear();
        $(".copyright_box .now_year").prepend("2011–"+currentYear+" ");

        if ($('body').hasClass('path-taxonomy')) {
            var page_title = document.getElementsByTagName('h1')[0];
            var page_title_clr = page_title.innerText || page_title.textContent;
            $('.breadcrumb .active').text(page_title_clr);
        }
/*        if ($('body').hasClass('path-katalog-kondicionery')) {
            $('.breadcrumb li:nth-child(3) a').text('Кондиционеры');
        }
        if ($('body').hasClass('path-katalog-ventilyaciya')) {
            $('.breadcrumb li:nth-child(3) a').text('Вентиляция');
        }
        if ($('body').hasClass('path-katalog-otoplenie')) {
            $('.breadcrumb li:nth-child(3) a').text('Отопление');
        }*/
    });
})(jQuery);